export default {
  computed: {
    isWeeklyTab() {
      return this.selectedTabObj?.id === -1;
    },
  },
};
